import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { history } from "../../utils/History";

import Table from "../../components/table";
import TableStatus from "../../components/table/status";
import SearchButton from "../../components/buttons/SearchButton";
import HeaderMenu from "../../components/commons/menu/HeaderMenu";
import DetailButton from "../../components/table/detailButton";
import MenuItem from "@material-ui/core/MenuItem";
import ConfirmationModal from "../../components/modal/ConfirmModal";
import Gallery from '../../store/actions/gallery/Index'

import GalleryModal from "./GalleryModal";
import moment from "moment";
import localization from "moment/locale/id";
import useLatestRequest from "../../components/hooks/useLatestRequest";
import {
  createDetailLocation,
  stringParam,
  useListQueryState,
} from "../../utils/listQueryState";

const GALLERY_QUERY_SCHEMA = {
    search: stringParam(),
};

const Index = ({ loggingIn }) => {

  
    const [dataGallery, setDataGallery] = useState([]);
    const [editGalleryModal, setEditGalleryModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [dataGalleryRow, setDataGalleryRow] = useState([]);

    
    const [addGalleryModal, setAddGalleryModal] = useState(false);
    const [registerModal, setRegisterModal] = useState(false);

    const { state: query, updateQuery, location } = useListQueryState(GALLERY_QUERY_SCHEMA);
    const { search: searchText } = query;
    const [isLoading, setIsLoading] = useState(false);
    const [loadError, setLoadError] = useState(null);
    const { beginRequest, isLatestRequest } = useLatestRequest();
    

    const dispatch = useDispatch();
    useEffect(() => {

      handleRefresh();

    }, [searchText]);

    const handleSearch = (value) => {
        updateQuery({ search: value?.length > 0 ? value : "" })
    }

    const handleRefresh = () => {
        const requestId = beginRequest();
        setIsLoading(true);
        setLoadError(null);
        new Promise((resolve, reject) => {
            let param = {
                page: 1,
                length: 50,
                search_text: searchText
            }
            dispatch(Gallery.get(param, resolve, reject));
        })
            .then(res => {
                if (!isLatestRequest(requestId)) return;

                setDataGallery(res?.data ?? [])
            })
            .catch((error) => {
                if (!isLatestRequest(requestId)) return;

                setLoadError(error?.response?.data?.message ?? "Data galeri gagal dimuat.")
            })
            .finally(() => {
                if (isLatestRequest(requestId)) {
                    setIsLoading(false)
                }
            })
    }

    const showEditGalleryModal = (data) => {
        setEditGalleryModal(!editGalleryModal)
        setDataGalleryRow(data ? data : [])
    }

    const showDeleteModal = (data) => {
        setDeleteModal(!deleteModal)
        setDataGalleryRow(data ? data : [])
    }

    const showAddGalleryModal = (data) => {
        setAddGalleryModal(!addGalleryModal)
    }

    const showRegisterModal = (data) => {
        setRegisterModal(!registerModal)
        // setDataPatientRow(data ? data : [])
    }

    const handleAdd = (param) => {
        const callback = () => {
            handleRefresh()
            setAddGalleryModal(!addGalleryModal)
        }

        dispatch(Gallery.postGallery(param, callback));
    };

    const handleDelete = () => {
        const callback = () => {
            handleRefresh()
            setDeleteModal(!deleteModal)
        }

        if (dataGalleryRow) {
            const id = dataGalleryRow?.id;
            dispatch(Gallery.deletedGallery(dataGalleryRow, callback))
        }
    }

    const handleEdit = (param) => {
        const callback = () => {
            handleRefresh()
            setEditGalleryModal(!editGalleryModal)
        }

        if (param) {
            dispatch(Gallery.updateGallery(param, callback))
        }
    }

    const handleAddRegister = (param) => {
        const callback = () => {
            handleRefresh()
            setAddGalleryModal(!addGalleryModal)
        }

        // new Promise((resolve) => {
        //     dispatch(PatientData.post(param, callback, resolve));
        // })
        //     .then(res => {
        //         showRegisterModal(res?.data)
        //     })
    }

    const columns = [
        {
        Header: "No",
        accessor: "no",
        },
        {
        Header: "NAMA GALERI",
        accessor: "name",
        },
        {
        Header: "TANGGAL POSTING",
        accessor: "published_at",
        Cell: ({ row }) => {
            const { original } = row;
            const {published_at} = original;
            const tanggal = moment(published_at).locale("id", localization).format("L") + ', ' + moment(published_at).locale("id", localization).format("LT")
            return tanggal
          }
        },
        {
        Header: "",
        accessor: "actions",
        Cell: ({ row }) => {
            const { original } = row;
            const { id, status } = original;

            return (

            <DetailButton>
                <MenuItem onClick={() => history.push(createDetailLocation(`/gallery-detail/${original?.id}`, location))}>
                    <span style={{ fontSize: 14 }}>Detail</span>
                </MenuItem>
                <MenuItem onClick={() => showEditGalleryModal(original)}>
                    <span style={{ fontSize: 14 }}>Edit</span>
                </MenuItem>
                <MenuItem onClick={() => showDeleteModal(original)}>
                    <span style={{ fontSize: 14 }}>Hapus</span>
                </MenuItem>
            </DetailButton>
            );
            
        },
        },
    ];

    return (
        <div className="menu-container">
            <div>
                <HeaderMenu
                    title="Galeri"
                    toolbarClassName="page-header-toolbar-split gallery-toolbar"
                >
                    <SearchButton
                        placeholder="Cari galeri"
                        value={searchText}
                        toggle={(value) => handleSearch(value)}
                    />
                    <button type="button" className="button mr-2 rounded-button primary button-default" onClick={()=>{showAddGalleryModal()}}>
                        <i className="fas fa-plus icon-button"></i>{' '} Tambah Galeri
                    </button>
                </HeaderMenu>
            </div>
            <div className="content-container-side">
                <div className="overflow">
                <Table
                    columns={columns}
                    data={dataGallery}
                    loading={isLoading}
                    error={loadError}
                    onRetry={handleRefresh}
                />
                </div>
            </div>

            {/* Modal */}
            <GalleryModal
                show={addGalleryModal}
                toggle={showAddGalleryModal}
                action={handleAdd}
                type="add"
                // register={(param) => handleAddRegister(param)}
            />

            <GalleryModal
                show={editGalleryModal}
                toggle={showEditGalleryModal}
                action={handleEdit}
                data={dataGalleryRow}
                // register={() => showRegisterModal(dataGalleryRow)}
            />
            
            <ConfirmationModal
                show={deleteModal}
                toggle={showDeleteModal}
                confirm={handleDelete}
                data={dataGalleryRow}
                message = {"Apakah Anda yakin ingin menghapus galeri ini?"}
                isConfirm = {"Ya, Hapus"}
                icon="info"
                isDelete
            >
            </ConfirmationModal>

        </div>

    );
};

export default Index;

